<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Отзывы</h4>
            <div class="sub-title">Все отзывы с площадок</div>
          </div>
        </div>
        <TopBlock></TopBlock>
        <!--        <div class="end-area">-->
        <!--          <a :href="project.report_file" target="_blank" class="btn btn-primary"><i class="bi bi-download"></i> Скачать-->
        <!--            полный отчёт</a>-->
        <!--        </div>-->
      </div>

    </div>
    <div class="block-filters sticky-top">
      <button class="btn btn-outline-secondary show-filters" @click="openFilter=!openFilter">
        <i class="bi bi-filter"></i>
        <template v-if="openFilter">Скрыть</template>
        <template v-else>Показать</template>
        фильтры
      </button>
      <div :class="'filters'+(openFilter?' open':'')">
        <div class="input-group search">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" v-model="filters.search" placeholder="Поиск по тексту отзыва..">
        </div>
        <MultiSelect v-if="resources.length"
                     v-model="filters.resources"
                     :options="resources"
                     :multi="true"
                     :only_value="true"
                     name="Площадки"></MultiSelect>
        <MultiSelect v-model="filters.tones"
                     :options="$TONES"
                     :multi="true"
                     :only_value="true"
                     name="Тональности"></MultiSelect>

        <MultiSelect v-model="filters.ratings"
                     :options="$RATING"
                     :multi="true"
                     :only_value="true"
                     name="Оценки"></MultiSelect>

        <MultiSelect v-model="filters.answers"
                     :options="$ANSWERS"
                     :multi="true"
                     :only_value="true"
                     name="Наличие ответа"></MultiSelect>

        <MultiSelect v-model="filters.our"
                     :options="[{id: 0, name: 'Нет'},{id: 1, name: 'Есть маркировка'}]"
                     :multi="false"
                     :only_value="true"
                     name="Наличие маркировки"></MultiSelect>

        <MultiSelect v-model="filters.mark"
                     :options="[{id: 0, name: 'Нет'},{id: 1, name: 'Да'}]"
                     :multi="false"
                     :only_value="true"
                     name="Наличие отметки"></MultiSelect>

      </div>
      <div :class="'filters'+(openFilter?' open':'')">
        <b>
          <i class="bi bi-tag"></i>
          Теги:
        </b>
        <template v-for="category in categoriesTag">
          <MultiSelect v-model="category.selected"
                       :options="category.tags"
                       :multi="true"
                       :name="category.name"></MultiSelect>
        </template>

        <div class="buttons ms-auto">
          <select class="order me-2" v-model="filters.order_by" name="" id="">
            <option>Сортировка</option>
            <option v-for="(order, key) in orders" :value="key" selected><span v-html="order"></span></option>
          </select>
          <button class="btn btn-primary me-2" @click="getData">Показать</button>
          <a href="" class="text-primary" @click.prevent="emptyFilter"><b>Сбросить все</b></a>
        </div>

      </div>
      <div :class="'filters stat'+(openFilter?' open':'')">
        <div class="data">
          Всего отзывов: <b>{{ all_count }}</b> <span class="separate">|</span>
          Показано: <b>{{ reviews.length }}</b> <span class="separate">|</span>
          <div class="tones">
            <div class="point"></div>
            Позитив: <b>{{ reviews.filter(x => x.tone === "positive").length }}</b>
            <div class="point negative"></div>
            Негатив: <b>{{ reviews.filter(x => x.tone === "negative").length }}</b>
          </div>
        </div>
        <div class="custom-filter" v-if="filter_name">
          <div class="name">Применён фильтр "{{ filter_name }}"</div>
          <a href="" @click.prevent="clearCustomFiter" title="сбросить фильтр"><i class="bi bi-x"></i></a>
        </div>


      </div>
    </div>


    <div class="responses">
      <template v-for="review in reviews">
        <SmallReview :review="review" :tags="tags" :show_answered="false"></SmallReview>
      </template>


      <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
                 v-bind:page="page"></PagerList>
    </div>

  </div>


</template>

<script>


import TopBlock from "@/components/TopBlock.vue";
import {ReviewApi} from "@/api/reviews";
import {ProjectApi} from "@/api/projects";
import PagerList from "@/components/PagerList.vue";
import datesMixin from "@/mixins/filterDates";
import {LinksApi} from "@/api/links";
import SmallReview from "@/views/dictionary/review/components/SmallReview.vue";

export default {
  name: 'ProjectReviews',
  data() {
    return {
      reviews: [],
      project: {},
      categoriesTag: [],
      orders: {
        "-date_response": "Дата создания &darr;",
        "date_response": "Дата создания &uarr;",
        "-rating": "Рейтинг &darr;",
        "rating": "Рейтинг  &uarr;",
      },
      filters: {
        search: '',
        resources: [],
        tones: [],
        ratings: [],
        answers: [],
        tags: [],
        order_by: "-date_response"
      },
      page: 1,
      size: 20,
      all_count: 0,
      openFilter: false,
      resources: [],
      tags: [],
      filter_name: "",
      review_ids: []

    }
  },
  mixins: [datesMixin],
  watch: {
    page(old, new_val) {
      this.updateURL()
      this.getData()
    },
    filters: {
      handler(val) {
        if (!this.isUpdatingFromURL) {
          this.page = 1
          this.updateURL()
        }
      },
      deep: true
    },
    categoriesTag: {
      handler(val) {

        if (!this.isUpdatingFromURL) {

          this.updateURL()
        }
      },
      deep: true
    },
    '$route': {
      handler(to, from) {
        if (to.path === this.$route.path) {
          this.loadFiltersFromURL()
        }
      },
      deep: true
    }
  },
  components: {SmallReview, PagerList, TopBlock},

  computed: {

    response_pager: {
      get() {
        return this.response_pager = this.$func.getPagerArray(this.all_count, this.size, this.page)
      },
      set() {
      }
    },

    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },
  mounted: function () {
    if (Object.keys(this.$route.query).length){
      this.clearCustomFiter()
    }
    else {
      let pendingReviewIds = localStorage.getItem(`pendingReviewIds_${this.project_id}`)
      if (pendingReviewIds) {
        let data = JSON.parse(pendingReviewIds)
        this.filter_name = data.name
        if (data.ids) this.review_ids = data.ids
      }
    }


    ProjectApi.object(this.project_id).then(response => this.project = response)
    LinksApi.review_domain_list().then(response => this.resources = response)
    ProjectApi.reviews_tags(this.$store.getters.currentProjectId, 1, 200).then(response => {
      this.categoriesTag = response
      this.loadTagsFromURL()
      this.loadFiltersFromURL()
      this.getData()
      this.categoriesTag.forEach(category => {
        this.tags = this.tags.concat(category.tags)
      })

    })

  },
  methods: {
    clearCustomFiter() {
      localStorage.removeItem('pendingReviewIds_' + this.project_id)
      this.filter_name = ""
      this.review_ids = [];
      this.getData()
    },

    updateURL() {
      const query = this.buildQueryObject()

      this.$router.replace({
        path: this.$route.path,
        query: query
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },
    emptyFilter() {
      this.isUpdatingFromURL = true

      this.categoriesTag.forEach(cat => {
        cat.selected = []
      });
      this.filters = {
        search: '',
        resources: [],
        tones: [],
        ratings: [],
        answers: [],
        tags: [],
        order_by: "-date_response"
      }
      this.page = 1

      this.isUpdatingFromURL = false
      this.$router.replace({path: this.$route.path, query: {}}).catch(() => {
      })
      this.getData()
    },
    updateResponsePage(page) {
      this.page = page
    },
    buildQueryObject() {
      const query = {}

      if (this.filters.search && this.filters.search.trim()) {
        query.search = this.filters.search.trim()
      }

      if (this.filters.order_by && this.filters.order_by !== "-date_response") {
        query.order_by = this.filters.order_by
      }
      let tags = [];
      this.categoriesTag.forEach(cat => {
        tags = tags.concat(cat.selected?.map(tag => tag.id) || [])
      })
      if (tags.length) {
        query.tags = tags.join(',')
      }

      if (this.filters.resources && this.filters.resources.length) {
        query.resources = this.filters.resources.join(',')
      }

      if (this.filters.tones && this.filters.tones.length) {
        query.tones = this.filters.tones.join(',')
      }

      if (this.filters.ratings && this.filters.ratings.length) {
        query.ratings = this.filters.ratings.join(',')
      }

      if (this.filters.answers && this.filters.answers.length) {
        query.answers = this.filters.answers.join(',')
      }

      if (String(this.filters.date_from)) {
        query.date_from = this.filters.date_from
      }

      if (String(this.filters.date_to)) {
        query.date_to = this.filters.date_to
      }

      if (String(this.filters.our)) {
        query.our = this.filters.our
      }

      if (String(this.filters.mark)) {
        query.mark = this.filters.mark
      }

      return query
    },
    loadFiltersFromURL() {
      this.isUpdatingFromURL = true

      const query = this.$route.query

      if (query.search) {
        this.filters.search = query.search
      } else {
        this.filters.search = ''
      }
      if (query.order_by && this.orders[query.order_by]) {
        this.filters.order_by = query.order_by
      } else {
        this.filters.order_by = "-date_response"
      }

      if (query.resources) {
        this.filters.resources = query.resources.split(',').filter(v => v)
      } else {
        this.filters.resources = []
      }

      if (query.tones) {
        this.filters.tones = query.tones.split(',').filter(v => v)
      } else {
        this.filters.tones = []
      }

      if (query.ratings) {
        this.filters.ratings = query.ratings.split(',').filter(v => v)
      } else {
        this.filters.ratings = []
      }

      if (query.answers) {
        this.filters.answers = query.answers.split(',').filter(v => v)
      } else {
        this.filters.answers = []
      }

      if (query.our) {
        this.filters.our = query.our
      }
      if (query.mark) {
        this.filters.mark = query.mark
      }
      if (query.date_from) {
        this.filters.date_from = query.date_from
      }
      if (query.date_to) {
        this.filters.date_to = query.date_to
      }

      this.isUpdatingFromURL = false
    },
    loadTagsFromURL() {
      const query = this.$route.query
      const tagIds = query.tags ? query.tags.split(',').map(id => parseInt(id)) : []
      this.categoriesTag.forEach(category => {
        category.selected = category.tags.filter(tag => tagIds.includes(tag.id)) || []
      })
    },
    getData() {
      let filters = JSON.parse(JSON.stringify(this.filters))
      filters.date_after = filters.date_from ? filters.date_from : this.date_from
      filters.date_before = filters.date_to ? filters.date_to : this.date_to
      filters.tags = [];
      if (this.review_ids) {
        const compressIds = (ids) => {
          const str = ids.join(',')
          return btoa(encodeURIComponent(str))
        }
        filters.review_ids = compressIds(this.review_ids)
      }

      this.categoriesTag.forEach(cat => {
        filters.tags = filters.tags.concat(cat.selected?.map(tag => tag.id))
      })

      if (filters.tags.length && !this.isUpdatingFromURL) {
        const query = {...this.$route.query}
        query.tags = filters.tags.join(',')
        this.$router.replace({query}).catch(() => {
        })
      }

      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value === null || value === undefined) {
          continue;
        }

        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item !== null && item !== undefined && item !== '') {
              searchParams.append(key, item);
            }
          });
        } else if (value !== '') {
          searchParams.append(key, value);
        }
      }

      const queryString = searchParams.toString();
      ReviewApi.get_reviews(this.page, this.size, queryString).then(response => {
        this.reviews = response.results
        this.all_count = response.count;
      })
    }
  }
}

</script>
<style scoped lang="scss">


.responses {
  display: flex;
  flex-direction: column;
  gap: 15px;


}


.custom-filter {
  display: flex;
  gap: 10px;
  margin-left: 20px;
  color: #1D4ED8;
  text-transform: uppercase;

  i {
    color: #B0341A;
    font-weight: bold;
    font-size: 14px;
  }
}

.block-filters {
  top: 70px;
  background: rgb(250, 250, 250);
  margin: 0 -20px 0 -20px;
  padding: 0 20px 0 20px;
}


@media (width < 768px) {

  .responses {
    margin-bottom: 80px;
  }
}

</style>
